import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useGlobalConfigContext } from '../../global-config'
import { getTenantLocale } from '../../i18n'
import {
  SeoHeadDescriptionMetas,
  SeoHeadHrefLangLinkTags,
  SeoHeadTitleMetas,
  type SeoHreflangLinkTagsContent,
} from '../../seo'
import { tenantLanguagesConfig } from '../../tenant'
import { urlResolverGetRedeemPaperPrescription } from '../../url-handling'

export const RxLpMetas: FC = () => {
  const intl = useIntl()
  const config = useGlobalConfigContext()

  const title = intl.formatMessage({ id: 'rx.meta.title' })
  const description = intl.formatMessage({ id: 'rx.meta.description' })

  const localisedVersions: SeoHreflangLinkTagsContent[] = tenantLanguagesConfig[
    config.tenant
  ].languages.map((language) => {
    return {
      href: `${config.shopUrl}${urlResolverGetRedeemPaperPrescription({ ...config, language, tenant: config.tenant })}`,
      hrefLang: getTenantLocale(config.tenant, language),
    }
  })

  return (
    <>
      <SeoHeadTitleMetas title={title} />
      <SeoHeadDescriptionMetas description={description} />
      <SeoHeadHrefLangLinkTags localisedVersions={localisedVersions} />
    </>
  )
}
